import React, { useMemo } from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import IndexRedirect from 'react-router/lib/IndexRedirect';

import AdminApp from './adminApp';
import Shops from './shops/components/shops';
import AddShop from './shops/containers/addShopContainer';
import ShopLayout from './shops/containers/ShopLayout';
import EditShop from './shops/containers/editShopContainer';
import PaymentSettings from './shops/containers/PaymentSettings';
import Loan from './shops/containers/LoanContainer';
import Users from './users/components/Users';
import AddUser from './users/components/AddUser';
import EditUser from './users/components/EditUser';
import CommissionSplitsListContainer from './splitsReport';
import Customers from './customers/Customers';
import Customer from './customers/containers/Customer';
import Subscription from './subscriptions/containers/SubscriptionContainer';
import BarberSubscriptions from './shops/containers/BarberSubscriptionsContainer';
import SubscriptionPlans from './subscriptionPlans/containers/SubscriptionPlans';
import NewSubscriptionPlan from './subscriptionPlans/containers/NewSubscriptionPlan';
import EditSubscriptionPlan from './subscriptionPlans/containers/EditSubscriptionPlan';
import HourlyWageRules from './shops/containers/hourlyWageRulesContainer';
import AddBrand from './brands/containers/addBrandContainer';
import EditBrand from './brands/containers/editBrandContainer';
import {
  ImportLayout,
  CustomersImport,
  AppointmentsImport,
  ProductsImport,
  ServicesImport,
  GiftCardsImport,
  ReviewsImport,
} from './shops/import';

import * as hooks from '../auth/routerHooks';
import BrandLayout from './brands/containers/BrandLayout';
import {
  BrandImportLayout,
  BrandCustomersImport,
  BrandGiftCardsImport,
  BrandProductsImport,
  BrandServicesImport,
} from './brands/import';
import AdminUsers from './users/components/AdminUsers';
import UsersList from './users/components/UsersList';

import { ShopList as UsersListV2 } from '../../modules/admin/users';
import { withLoadAdminShops } from './shops/hoc/withLoadAdminShops';
import { FullstoryService } from '../../modules/infra/observability/fullstory';
import { ExternalAppsImport } from '../../modules/admin/shops/import/external-platforms-import';
import { BrandList } from '../../modules/admin/brands/brand-list';

const UserListComponentRouter = () => {
  const [isFullListForced, setIsFullListForced] = React.useState(false);

  const UsersListV1 = useMemo(() => (
    isFullListForced ? withLoadAdminShops(UsersList) : UsersList
  ), [isFullListForced]);

  const handleShowAllClick = () => {
    setIsFullListForced(true);
    FullstoryService.track('Sys Admin Show All Users Clicked');
  };

  const UserListComponent = (!isFullListForced) ? UsersListV2 : UsersListV1;
  return <UserListComponent onShowAllClick={handleShowAllClick} />;
};

export default (store) => (
  <Route path="/admin" component={AdminApp} onEnter={hooks.requireAdmin(store)}>
    <IndexRedirect to="users" />
    <Route path="shops" name="shops">
      <IndexRoute component={withLoadAdminShops(Shops)} />
      <Route path="add" component={AddShop} />
      <Route component={withLoadAdminShops(ShopLayout)}>
        <Route path=":id" component={EditShop} />
        <Route path=":id/payment" component={PaymentSettings}>
          <Route path=":barberId" name="payment" />
        </Route>
        <Route path=":id/import" component={ImportLayout}>
          <IndexRedirect to="customers" />
          <Route path="customers" component={CustomersImport} />
          <Route path="appointments" component={AppointmentsImport} />
          <Route path="products" component={ProductsImport} />
          <Route path="services" component={ServicesImport} />
          <Route path="gift-cards" component={GiftCardsImport} />
          <Route path="auto-import" component={ExternalAppsImport} />
          <Route path="reviews" component={ReviewsImport} />
        </Route>
        <Route path=":id/subscription(/:barberId)" name="subscription" component={BarberSubscriptions} />
        <Route path=":id/loan" name="loan" component={Loan} />
        <Route path=":id/hourly-wage-rules" name="hourly-wage-rules" component={HourlyWageRules} />
      </Route>
    </Route>
    <Route path="users" name="users">
      <Route component={Users}>
        <IndexRoute component={UserListComponentRouter} />
        <Route path="admin-users" component={AdminUsers} />
      </Route>
      <Route path="add" component={withLoadAdminShops(AddUser)} />
      <Route path=":id" component={withLoadAdminShops(EditUser)} />
    </Route>
    <Route path="customers">
      <IndexRoute component={Customers} />
      <Route path=":id" component={Customer} />
    </Route>
    <Route path="commission-splits" component={withLoadAdminShops(CommissionSplitsListContainer)} />
    <Route path="subscription/plans">
      <IndexRoute component={SubscriptionPlans} />
      <Route path="new" component={NewSubscriptionPlan} />
      <Route path=":id" component={EditSubscriptionPlan} />
    </Route>
    <Route path="brands" name="brands">
      <IndexRoute component={BrandList} />
      <Route path="add" component={withLoadAdminShops(AddBrand)} />
      <Route component={withLoadAdminShops(BrandLayout)}>
        <Route path=":id" component={EditBrand} />
        <Route path=":id/subscription" name="subscription" component={Subscription} />
        <Route path=":id/import" component={BrandImportLayout}>
          <IndexRedirect to="customers" />
          <Route path="customers" component={BrandCustomersImport} />
          <Route path="gift-cards" component={BrandGiftCardsImport} />
          <Route path="products" component={BrandProductsImport} />
          <Route path="services" component={BrandServicesImport} />
        </Route>
      </Route>
    </Route>
  </Route>
);
